import request from "@/utils/request.js";
const api = {
  loan_one: (data, setting) => {
    return request.post('/api/loan/loan_one', data, setting)
  },
  id_card_orc: (data, setting) => {
    return request.post('/api/loan/id_card_orc', data, setting)
  },
  face_id_card: (data, setting) => {
    return request.post('/api/loan/face_id_card', data, setting)
  },
  get_info: (data, setting) => {
    return request.post('/api/loan/get_info', data, setting)
  },
  enter_detail: (data, setting) => {
    return request.post('/api/loan/enter_detail', data, setting)
  },
  voice: (data, setting) => {
    return request.post('/api/loan/voice', data, setting)
  }
}


export default api